import Chat from "@/pages/Chat";
import {createFileRoute} from "@tanstack/react-router";
import {zodValidator} from "@tanstack/zod-adapter";
import {z} from "zod";

export const Route = createFileRoute(
  "/_authenticated/_company/company/$companyId/chat/{-$campaignId}/{-$influencerUserId}",
)({
  component: Chat,
  params: {
    parse: raw => ({
      companyId: +raw.companyId,
      campaignId: raw.campaignId ? +raw.campaignId : undefined,
      influencerUserId: raw.influencerUserId ? +raw.influencerUserId : undefined,
    }),
    stringify: params => ({
      companyId: params.companyId?.toString(),
      campaignId: params.campaignId?.toString(),
      influencerUserId: params.influencerUserId?.toString(),
    }),
  },
  validateSearch: zodValidator(
    z.object({
      isBulk: z.boolean().optional(),
      isNeedsReply: z.boolean().optional(),
      search: z.string().optional(),
    }),
  ),
});
